export default __webpack_public_path__ + "static/media/circles.be1ff3c5.svg";